import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { israelIDValidator } from 'src/app/validators/isarel-id.validator';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { windowProvider } from 'ngx-owl-carousel-o/lib/services/window-ref.service';
import { AppServiceService } from 'src/app/core/services/app-service.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  mobile: string;
  tabIndex = 1;
  sitekey: string;
  gRacptcha:string;
  constructor(private router: Router, private location: Location, private activatedRoute: ActivatedRoute ,private _appService:AppServiceService) { }

  ngOnInit(): void {
    if (window['_loginType'] == window['_loginTypeUsernameSMSOTP']) {
      this.tabIndex = 1;
    }
    else if (window['_loginType'] == window['_loginTypeUsernamePassword']) {
      this.tabIndex = 2;
    }
    else if(window['_loginType'] == window['_loginTypeOTPOnly']){
      this.tabIndex = 1;
    }
    else if(window['_loginType'] == window['_loginTypeMOEUserPassSMS']){
      this.tabIndex = 1;
    }
  }

  loginByPassword() {
    window.location.href = window['_loginMethodUsernamePasswordURL'];
  }

  loginBySms() {
    if(this._appService.componentName == this._appService.listComponentName['loginViaOtp'] ){
      this._appService.doReset();
    }
    else{
          window.location.href = window['_loginMethodUsernameSMSOTPURL'];

    }
  }


  sendOtp(otp: string) {
    this.mobile = otp;
    this.tabIndex = 3;
  }


}
